var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 36.2969H38.4531V7.1875C38.4531 6.90156 38.3395 6.62734 38.1374 6.42515C37.9352 6.22296 37.6609 6.10938 37.375 6.10938H27.3125C27.0266 6.10938 26.7523 6.22296 26.5501 6.42515C26.348 6.62734 26.2344 6.90156 26.2344 7.1875V14.7344H17.25C16.9641 14.7344 16.6898 14.848 16.4877 15.0502C16.2855 15.2523 16.1719 15.5266 16.1719 15.8125V23.3594H8.625C8.33906 23.3594 8.06484 23.473 7.86265 23.6751C7.66046 23.8773 7.54688 24.1516 7.54688 24.4375V36.2969H5.75C5.46406 36.2969 5.18984 36.4105 4.98765 36.6126C4.78546 36.8148 4.67188 37.0891 4.67188 37.375C4.67188 37.6609 4.78546 37.9352 4.98765 38.1374C5.18984 38.3395 5.46406 38.4531 5.75 38.4531H40.25C40.5359 38.4531 40.8102 38.3395 41.0124 38.1374C41.2145 37.9352 41.3281 37.6609 41.3281 37.375C41.3281 37.0891 41.2145 36.8148 41.0124 36.6126C40.8102 36.4105 40.5359 36.2969 40.25 36.2969ZM28.3906 8.26562H36.2969V36.2969H28.3906V8.26562ZM18.3281 16.8906H26.2344V36.2969H18.3281V16.8906ZM9.70312 25.5156H16.1719V36.2969H9.70312V25.5156Z",
    fill: "url(#paint0_linear_1486_7386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_7386",
    x1: 23,
    y1: 6.10937,
    x2: 23,
    y2: 38.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#037FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FD64D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/BarChart.31cf6d363ed37757a0d1a17b61adc72f.svg";
export { ForwardRef as ReactComponent };